import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type ChatStoreSlice = {
  userIdToOpenDialogInChatWith : {
    userId: string | null,
  },
  chatToClose: symbol | null,
};

const initialState: ChatStoreSlice = {
  userIdToOpenDialogInChatWith: {
    userId: null,
  },
  chatToClose: null,
};

const chatSlice = createSlice({
  name: "chat",
  initialState,
  reducers: {
    openDialogInChatWithUserId(state, { payload }: PayloadAction<{ userId: string }>) {
      state.userIdToOpenDialogInChatWith = { userId: payload.userId };
    },
    closeChat(state) {
      state.chatToClose = Symbol("chat to close");
    },
  },
});

export const {
  openDialogInChatWithUserId,
  closeChat,
} = chatSlice.actions;

export default chatSlice.reducer;
